'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '_async_computed$';

exports.default = {
  install: function install(Vue, options) {
    options = options || {};

    Vue.config.optionMergeStrategies.asyncComputed = Vue.config.optionMergeStrategies.computed;

    Vue.mixin({
      created: function created() {
        var _this = this;

        Object.keys(this.$options.asyncComputed || {}).forEach(function (key) {
          var fn = _this.$options.asyncComputed[key];
          if (!_this.$options.computed) _this.$options.computed = {};
          Vue.set(_this.$options.computed, prefix + key, fn);
          Vue.set(_this, key, null);
        });

        this._initComputed();

        Object.keys(this.$options.asyncComputed || {}).forEach(function (key) {
          var promiseId = 0;
          _this.$watch(prefix + key, function (newPromise) {
            var thisPromise = ++promiseId;
            newPromise.then(function (value) {
              if (thisPromise !== promiseId) return;
              _this[key] = value;
            }).catch(function (err) {
              if (thisPromise !== promiseId) return;

              if (options.errorHandler === false) return;

              var handler = options.errorHandler === undefined ? console.error.bind(console, 'Error evaluating async computed property:') : options.errorHandler;

              handler(err.stack);
            });
          }, { immediate: true });
        });
      }
    });
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/vue-async-computed/dist/index.js
// module id = 736
// module chunks = 1